import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "display": "flex"
  }
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { addProductCategoryApi, updateProductCategoryByIdApi } from "@/service/modules/product";
export default /*@__PURE__*/_defineComponent({
  __name: 'category-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "add"
    },
    categoryData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["closeDialog", "update:dialogVisible"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const form = reactive({
      categoryName: "",
      secondCategory: []
    });
    let secondCategoryName = ref("");
    const rules = reactive({
      categoryName: [{
        required: true,
        message: "请输入类目名称",
        trigger: "blur"
      }, {
        min: 1,
        max: 50,
        message: "长度在1到50个字符",
        trigger: "blur"
      }]
    });
    // const tags = ref<any[]>([]);
    function addTag() {
      form.secondCategory.push({
        categoryName: secondCategoryName.value
      });
      secondCategoryName.value = "";
    }
    function closeTag(index) {
      form.secondCategory.splice(index, 1);
    }
    watch(() => props.dialogVisible, val => {
      if (val) {
        form.categoryName = props.categoryData.categoryName;
        form.secondCategory = props.categoryData.secondCategory || [];
        // console.log(form,'form',props.categoryData);
      }
    }, {
      deep: true
    });
    function handleCancel() {
      resetForm();
      emit("closeDialog");
    }
    async function handleConfirm() {
      formRef.value?.validate(async valid => {
        if (valid) {
          if (props.dialogType === "add") {
            // 处理添加逻辑
            try {
              await addProductCategoryApi(form);
              ElMessage.success("添加成功");
            } catch (error) {
              ElMessage.error("添加失败");
            }
          } else {
            // 处理编辑逻辑
            try {
              await updateProductCategoryByIdApi(props.categoryData.id, form);
              ElMessage.success("编辑成功");
            } catch (error) {
              ElMessage.error("编辑失败");
            }
          }
          resetForm();
          emit("closeDialog");
        }
      });
    }
    function resetForm() {
      form.categoryName = "";
      formRef.value?.resetFields();
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$emit('update:dialogVisible')),
        title: __props.dialogType === 'add' ? '新增类目' : '编辑类目',
        width: "500px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "130px",
          class: "category-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "一级目录名称：",
            prop: "categoryName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.categoryName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.categoryName = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "二级目录名称：",
            prop: "secondCategoryName"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
              modelValue: _unref(secondCategoryName),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(secondCategoryName) ? secondCategoryName.value = $event : secondCategoryName = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              style: {
                "margin-left": "10px"
              },
              onClick: addTag
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("添加")])),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.secondCategory, (tag, index) => {
          return _openBlock(), _createBlock(_component_el_tag, {
            style: {
              "margin-right": "10px"
            },
            key: index,
            closable: "",
            onClose: $event => closeTag(index),
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.categoryName), 1)]),
            _: 2
          }, 1032, ["onClose"]);
        }), 128))])]),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
});